import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {handleActiveToast} from "../../components/sonner/ToastBasic";

async function getSlaList(search, pageable) {
    console.log(">> SLA목록 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {

            sort += desc;
        }
    }

    const searchDto = {};
    for (const key in search) {
        if (search.hasOwnProperty(key)) {
            if (typeof search[key] === 'object' && search[key] !== null) {
                searchDto[key] = search[key].id;
            } else {
                searchDto[key] = search[key];
            }
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/evaluation/slaCompare?'+pageStr,searchDto);
    }catch (error){
        return error;
    }
}

async function saveSla(data) {
    return await needAuth.post(`/evaluation/slaCompare/create`, data);
}

async function updateSla(data) {
    return  await needAuth.put(`/evaluation/slaCompare`, data);
}

async function getRecentDataByMonth(month){
    return await needAuth.get(`/evaluation/slaCompare/${month}`);
}

async function getDataByMonth(month){
    return await needAuth.get(`/evaluation/slaCompare/update/${month}`);
}




async function getSlaMonthList(search, pageable) {
    console.log(">> SLA 월별보고서 목록 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        // sort += "month"
        if (pageable.desc) {

            sort += desc;
        }
    }

    const searchDto = {};
    for (const key in search) {
        if (search.hasOwnProperty(key)) {
            if (typeof search[key] === 'object' && search[key] !== null) {
                searchDto[key] = search[key].id;
            } else {
                searchDto[key] = search[key];
            }
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/evaluation/slaCompare/report?'+pageStr,searchDto);
    }catch (error){
        return error;
    }
}

async function getSlaReportData(id){
    return await needAuth.get(`/evaluation/slaCompare/report/${id}`);
}

async function removeSlaReports(ids) {
    return await needAuth.put('/evaluation/slaCompare/report/delete', ids);
}

async function updateSlaReport(data){
    return await needAuth.put('/evaluation/slaCompare/report/update', data);
}

export {getSlaList, saveSla, updateSla, getRecentDataByMonth, getDataByMonth, getSlaMonthList, getSlaReportData, removeSlaReports, updateSlaReport};